module.exports = __webpack_public_path__ + "static/img/xqs_jjh_qrcode.ce3a0bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xqs_jjh_qrcode.jpg
// module id = CAWs
// module chunks = 21